import type { Plan } from '../../shared/api/types';
import { formatPrice } from './format';

/** Elegir paquete: tarjetas seleccionables (radio) con precio mensual y días de prueba. */
export function PlanPicker({ plans, value, onChange }: { plans: Plan[]; value: string; onChange: (code: string) => void }) {
  return (
    <fieldset className="plans">
      <legend>Plan</legend>
      {plans.map((plan) => (
        <label key={plan.code} className={`plan${value === plan.code ? ' plan--selected' : ''}`}>
          <input type="radio" name="planCode" value={plan.code} checked={value === plan.code} onChange={() => onChange(plan.code)} />
          <span className="plan__name">{plan.name}</span>
          <span className="plan__price">
            {formatPrice(plan.monthlyPriceCents, plan.currency)} <span className="muted small">al mes</span>
          </span>
          {plan.description ? <span className="muted small">{plan.description}</span> : null}
          {plan.trialDays > 0 ? <span className="badge badge--active">{plan.trialDays} días de prueba</span> : null}
        </label>
      ))}
    </fieldset>
  );
}
